import React from 'react'

const Header = () => {
	return (
		<header className='container_header'>
			<img
				src='https://registrate.profuturo.mx/rs/117-UEL-823/images/logo_final.svg'
				alt='Logo'
				className='img img-logo'
			/>
		</header>
	)
}

export default Header
